import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'sanitize.css';
import 'sanitize.css/forms.css';
import 'sanitize.css/typography.css';
import App from './App';
import CreditsUtils from './credits/lib/CreditsUtils';
import IndexUtil from './database/lib/IndexUtil';
import ItemUtil from './database/lib/ItemUtil';
import './index.css';
import MediaWikiUtils from './mediawiki/lib/MediaWikiUtils';
import PicoUtils from './pico/lib/PicoUtils';
import { loadSiteData, setSiteData } from './siteData';

const container = document.getElementById('root');
if (container === null) {
    throw new Error('Root container #root was not found in the document.');
}

// The converted XOOPS data is served with static-contents/, so it is fetched
// before the first render. Components can then read it synchronously.
loadSiteData()
    .then((data) => {
        setSiteData(data);
        IndexUtil.init(data.tree);
        ItemUtil.initSimpfLinks(data.simpfLinks);
        CreditsUtils.init(data.credits);
        PicoUtils.init(data.pico);
        MediaWikiUtils.init(data.mediawiki);
        createRoot(container).render(
            <StrictMode>
                <App />
            </StrictMode>
        );
    })
    .catch((error: unknown) => {
        console.error('failed to load the site data', error);
        container.textContent = 'Failed to load the site data.';
    });
